import { render, staticRenderFns } from "./DimensionExtItem.vue?vue&type=template&id=2873f3ad&scoped=true&"
import script from "./DimensionExtItem.vue?vue&type=script&lang=js&"
export * from "./DimensionExtItem.vue?vue&type=script&lang=js&"
import style0 from "./DimensionExtItem.vue?vue&type=style&index=0&id=2873f3ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2873f3ad",
  null
  
)

export default component.exports